exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-img {\n  text-align: center;\n  width: 100%; }\n  .preview-img img {\n    width: 100%;\n    height: auto;\n    pointer-events: none; }\n\n.preview-video {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  text-align: center;\n  line-height: 0;\n  width: 100%;\n  border-radius: 0;\n  -ms-flex-pack: center;\n      justify-content: center;\n  border: none; }\n  .preview-video video {\n    width: 100%;\n    max-height: 100%; }\n\n.video .preview-img {\n  display: none; }\n\n.image .preview-video {\n  display: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/components/preview/preview.component.scss
// module id = ../../../../../src/app/components/preview/preview.component.scss
// module chunks = main